import { DeleteOutlined } from '@ant-design/icons';

import Typo from '@/components/Typography/Typo';
import type { HeySynclyHistory } from '@/entities/hey-syncly';
import { cn } from '@/lib/cn';
import { popup } from '@/stores/pure/PopupStore';

type Props = {
  history: HeySynclyHistory;
  selected: boolean;
  onClick: (alias: Alias) => void;
  onDeleteClick: (alias: Alias) => void;
};
export const HistoryItem = (props: Props) => {
  const { history, onClick, onDeleteClick } = props;
  const { alias, title } = history;
  return (
    <div
      className={cn(
        'relative flex justify-between items-center hover:bg-gray-200 py-2.5 px-3.5 rounded-md cursor-pointer transition-all duration-200 group',
        props.selected && 'bg-gray-250',
      )}
      onClick={(e) => {
        e.stopPropagation();
        onClick(alias);
      }}
    >
      <Typo
        type="body2"
        weight="r"
        className="text-gray-800"
        multilineEllipsis={2}
      >
        {title}
      </Typo>
      <button
        className={cn(
          'absolute right-2 top-[50%] -translate-y-1/2 z-10',
          'size-8 rounded-sm bg-gray-200 flex items-center justify-center cursor-pointer',
          'hover:bg-gray-300 opacity-0 group-hover:opacity-100 transition-opacity duration-200',
        )}
        onClick={(e) => {
          e.stopPropagation();
          popup({
            type: 'confirm',
            popupTheme: 'negative',
            title: 'Delete Conversation',
            message: 'Are you sure you want to delete this conversation?',
            confirmText: 'Delete',
            cancelText: 'Cancel',
            onConfirm: () => {
              onDeleteClick(alias);
            },
          });
        }}
      >
        <DeleteOutlined style={{ fontSize: 14 }} />
      </button>
    </div>
  );
};
